import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import AssetReuseStatus from "./components/AssetReuseStatus";
import InboundOutboundStatus from "./components/InboundOutboundStatus";
import AssetDept from "./components/AssetDept";
import ProjectServe from "./components/ProjectServe";
import SharedAssets from "./components/SharedAssets";
import AssetMap from "@/components/AssetMap";
import AssetMapMinhang from "@/components/AssetMapMinhang";
import AssetMapPudong from "@/components/AssetMapPudong";
import AssetMapFloor from "@/components/AssetMapFloor";
import TotalAssetChange from "./components/TotalAssetChange";
import ProportionAssets from "./components/ProportionAssets";
import { Modal } from "antd";
export default function UAM() {
    const [modal, contextHolder] = Modal.useModal();
    const [minhangVisible, setMinhangVisible] = useState(false);
    const [pudongVisible, setPudongVisible] = useState(false);
    const [floorVisible, setFloorVisible] = useState(false);
    const minhangRef = useRef(null);
    const pudongRef = useRef(null);
    const floorUrl = useRef("");
    const floorInfo = useRef({});
    function handleClick(params) {
        if (params == "闵行区") {
            setMinhangVisible(true);
        }
        else if (params == "浦东新区") {
            setPudongVisible(true);
        }
    }
    useEffect(() => {
        if (minhangVisible) {
            minhangRef.current?.renRenderLoop?.();
        }
        else {
            minhangRef.current?.stopRenderLoop?.();
        }
    }, [minhangVisible]);
    useEffect(() => {
        if (pudongVisible) {
            pudongRef.current?.renRenderLoop?.();
        }
        else {
            pudongRef.current?.stopRenderLoop?.();
        }
    }, [pudongVisible]);
    useEffect(() => {
        if (floorVisible) {
            minhangRef.current?.stopRenderLoop?.();
        }
        else {
            minhangRef.current?.renRenderLoop?.();
        }
    }, [floorVisible]);
    const onPointClick = (pointInfo) => {
        let { pointData } = pointInfo;
        if (pointData) {
            floorInfo.current = pointInfo;
            floorUrl.current = pointData;
            setFloorVisible(true);
        }
        else {
            modal.error({
                title: "加载楼层失败",
                content: "请检查JSON数据",
            });
        }
    };
    return (_jsxs("div", { className: "flex-1 w-full p-[0.3rem] overflow-hidden min-h-0", children: [_jsx("style", { children: `
          /* 1. 最外层包裹层：四边全清 */
          .ant-modal-wrap {
            inset: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            overflow: hidden !important;
          }

          /* 2. AntD 6 container层：四边全清 */
          .ant-modal-container {
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
          }

          /* 3. 锁死页面滚动条 */
          html:has(.ant-modal-wrap),
          body:has(.ant-modal-wrap) {
            overflow: hidden !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          /* 4. Modal 主体：四边全清 */
          .ant-modal {
            inset: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            max-width: 100vw !important;
            border-radius: 0 !important;
          }

          /* 5. Modal 内容层：四边全清+透明背景 */
          .ant-modal-content {
            width: 100vw !important;
            height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            border-radius: 0 !important;
            background-color: transparent !important;
          }

          /* 6. Modal body：四边全清 */
          .ant-modal-body {
            width: 100vw !important;
            height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            overflow: hidden !important;
          }
        ` }), _jsxs("div", { className: "flex gap-[0.05rem] h-full", children: [_jsxs("div", { className: "flex flex-col gap-[0.05rem]  w-[4.47rem] flex-shrink-0 ", children: [_jsx("div", { className: "flex-1 min-h-0", children: _jsx(ProportionAssets, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(SharedAssets, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(TotalAssetChange, { className: "w-full h-full" }) })] }), _jsxs("div", { className: "flex flex-col flex-1", children: [_jsxs("div", { className: "flex-[67.0%] min-h-0", children: [_jsx(AssetMap, { className: "w-full h-full", url: "/uam/datav/screen/area/0", onClick: handleClick }), _jsx(Modal, { open: minhangVisible, onCancel: () => setMinhangVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapMinhang, { ref: minhangRef, onPointClick: onPointClick, type: "uam" }) }), _jsx(Modal, { open: pudongVisible, onCancel: () => setPudongVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapPudong, { ref: pudongRef, onPointClick: onPointClick, type: "uam" }) }), _jsx(Modal, { open: floorVisible, onCancel: () => setFloorVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapFloor, { jsonUrl: floorUrl.current, floorInfo: floorInfo.current, type: "uam" }) })] }), _jsx("div", { className: "flex-[33%] min-h-0", children: _jsx(AssetDept, { className: "w-full h-full" }) })] }), _jsxs("div", { className: "flex flex-col gap-[0.05rem] flex-shrink-0 w-[4.47rem]", children: [_jsx("div", { className: "flex-1 min-h-0", children: _jsx(ProjectServe, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(AssetReuseStatus, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(InboundOutboundStatus, { className: "w-full h-full" }) })] })] })] }));
}
